import React, { useState } from "react";
import ContentHeaderUi from "./ContentHeaderUi";
import { useNavigate } from "react-router-dom";
import { removeUserToken } from "../../store/slice";
import { useDispatch } from "react-redux";
import { resetSelectedCEN } from "../../store/cenSlice";
import { useDecodeToken } from "../../Utils/function";

function ContentHeader({
  title,
  buttonName,
  buttonBoolean,
  pageName,
  linkPath,
  backButton,
  // decodedToken,
}) {
  const decodedToken = useDecodeToken();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onBack = () => {
    navigate(-1);
  };

  const logOut = () => {
    dispatch(resetSelectedCEN());
    dispatch(removeUserToken({}));
    navigate("/login")
  };

  return (
    <div>
      <ContentHeaderUi
        title={title}
        buttonName={buttonName}
        buttonBoolean={buttonBoolean}
        pageName={pageName}
        linkPath={linkPath}
        onBack={onBack}
        backButton={backButton}
        decodedToken={decodedToken}
        logOut={logOut}
      />
    </div>
  );
}

export default ContentHeader;
